import React, { useState, useEffect } from "react";
import Clientsidebar from "../components/Clientsidebar";
import Clientheader from "../components/Clientheader";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { useYearContext } from "../../admin/components/YearContext";
import { loadStripe } from "@stripe/stripe-js";
import { useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";




function Clientinvoices() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();

  const [username, setUsername] = useState("");
  const token = Cookies.get("token");
  useEffect(() => {
    if (!token) {
      // No token, redirect to home
      // navigate("/");
    } else {
      try {
        const decoded = jwtDecode(token);
        setUsername(decoded.email);

        // If the decoded role is not Client, redirect
        if (decoded.role !== "client") {
          // navigate("/");
        }
      } catch (error) {
        console.error("Invalid token");
        // navigate("/");
      }
    }
  }, []);

  const [invoiceData, setInvoiceData] = useState([]);
  useEffect(() => {
    if (username) {
      fetchclientinvoices();
    }
  }, [username]);

  const fetchclientinvoices = async () => {
    if (!username) {
      console.error("Username is missing.");
      return;
    }

    try {
      const response = await axios.get(
        `https://api.easytaxexperts.com/getclientinvoices/${username}`
      );
      if (response.data.success) {
        setInvoiceData(response.data.result);
      }
    } catch (error) {
      console.error("Error fetching client invoices:", error);
      if (error.response) {
        console.error(
          `Error ${error.response.status}: ${error.response.data.message}`
        );
      }
    }
  };

  //stripe payment
const [searchParams] = useSearchParams();

useEffect(() => {
  const payment = searchParams.get("payment");
  const invoiceId = searchParams.get("invoice_id");

  if (payment === "success") {
    Swal.fire({
      title: "🎉 Payment Successful!",
      text: `Invoice ${invoiceId} has been paid.`,
      icon: "success",
    });

    fetchclientinvoices(); // refresh data
  }

  if (payment === "cancel") {
    Swal.fire({
      title: "❌ Payment Cancelled",
      text: "You cancelled the payment. You can try again.",
      icon: "error",
    });
  }
}, []);

  const paymentHandler = async (services, totalBill, discount, referal) => {
    const stripe = await loadStripe(
      "pk_live_51Si0nELwT3JMwXBUXhnfx45U2PzrjvXnsigqDB3CXbEFJf0RSrEZ1XG1QJZFfcKb2On7HbC3XjwSFvQWKypI5sgl00h5OGVTJ5"
    );

    const body = {
      services: services,
      total: totalBill,
      discount: discount,
      referal: referal,
    };

    const headers = {
      "Content-Type": "application/json",
    };

    try {
      const response = await fetch(
        "https://api.easytaxexperts.com/create-checkout-session",
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(body),
        }
      );

      const session = await response.json();

      if (session.id) {
        const result = await stripe.redirectToCheckout({
          sessionId: session.id,
        });

        if (result.error) {
          console.log(result.error);
        }
      } else {
        console.error("No session ID returned:", session);
      }
    } catch (error) {
      console.error("Error during payment process:", error);
    }
  };

  const filterDocuments = invoiceData.filter((each) => {
    const documentDate = each.InvoiceDate ? each.InvoiceDate : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();
    // const startDate = `${parseInt(nextYear) - 1}-09-01`;
    // const endDate = `${nextYear}-08-31`;
const startDate = `${parseInt(nextYear) - 1}-11-30`;
const endDate = `${nextYear}-11-29`;

    const isYearMatch = documentDate >= startDate && documentDate <= endDate;

    return isYearMatch;
  });

  const reverseDocument = filterDocuments.slice().reverse();

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 100;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = reverseDocument.slice(firstIndex, lastIndex);
  const npage = Math.ceil(filterDocuments.length / recordsPerPage);
  const numbers = [...Array(npage + 1).keys()].slice(1);

  const prePage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const changeCpage = (id) => {
    setCurrentPage(id);
  };
  const nextPage = () => {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  };
  return (
    <div className="client-grid-container">
      <Clientheader openSidebar={openSidebar} />
      <Clientsidebar
        openSidebarToggle={openSidebarToggle}
        openSidebar={openSidebar}
      />
      <main className="main-container mt-2">
        <div className="container">
          <div className="table-invcontainer">
          <div className="table-responsive tablediv">
            <table className="table table-bordered table-hover">
              <thead className="table-primary">
                <tr>
                  <th>S.No</th>
                  <th>Invoice ID</th>
                  <th>ClientName</th>
                  <th>Phone Number</th>
                  <th>Email</th>
                  <th>Invoice Date</th>
                  <th>Services</th>
                  <th>SSN</th>
                  {/* <th>Caller Name</th>  */}
                  <th>Discount</th>
                  <th>Referral</th>
                  <th>Total Bill</th>
                  <th>Payment Status</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {records.map((each, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
                    <td>{each.invoiceId}</td>
                    <td>{each.userName}</td>
                    <td>{each.phoneNumber}</td>
                    <td>{each.email}</td>
                    <td>{each.InvoiceDate}</td>
                    <td>
                      {each.Services ? (
                        Array.isArray(JSON.parse(each.Services)) &&
                        JSON.parse(each.Services).length > 0 ? (
                          JSON.parse(each.Services).map((record, index) => (
                            <ul key={index}>
                               <li>
            {record.service} - ${record.price}{" "}
            {record.state ? `(${record.state})` : ""}
          </li>
                            </ul>
                          ))
                        ) : (
                          <p>No records</p>
                        )
                      ) : (
                        <p>Loading...</p>
                      )}
                    </td>
                    <td>{each.SSN}</td>
                    {/* <td>{each.CallerName}</td> */}
                    <td>{each.Discount}</td>
                    <td>{each.Referal}</td>
                    <td>{each.totalBill}</td>
                    <td>{each.PaymentStatus} </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-success"
                        disabled={each.PaymentStatus == "Paid"}
                        onClick={() =>
                          paymentHandler(
                            each.Services,
                            each.totalBill,
                            each.Discount,
                            each.Referal
                          )
                        }
                      >
                        Pay
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          </div>
          <nav className="mt-2">
            <ul className="pagination">
              <li className="page-item">
                <a href="#" className="page-link" onClick={prePage}>
                  Prev
                </a>
              </li>
              {numbers.map((n, i) => {
                return (
                  <li
                    className={`page-item ${currentPage === n ? "active" : ""}`}
                    key={i}
                  >
                    <a
                      href="#"
                      className="page-link"
                      onClick={() => changeCpage(n)}
                    >
                      {n}
                    </a>
                  </li>
                );
              })}
              <li className="page-item">
                <a href="#" className="page-link" onClick={nextPage}>
                  Next
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </main>
    </div>
  );
}

export default Clientinvoices;
